module.exports = __webpack_public_path__ + "img/163144.2c9c4e6a.jpg";